import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function CarConsumption(props) {

    const [carId, setCarId] = useState(props.row.privateId);
    const [consumption, setConsumption] = useState([]);

    const callApi = useCallback(async () => {
        const response = await axios.get(`/api/cardayrefuel/${carId}`)
        console.log(response.data);
        return response.data;
    }, [carId]);

    useEffect(function () {
        console.log(props);
        callApi()
            .then(res => setConsumption(res))
            .catch(err => console.log(err));
    }, []);

    const formatNumber = (num) => {
        return num.toLocaleString(); // Adds spaces for thousands separators
    };

    const formatConsumption = (num) => {
        return num.toFixed(2); // Two decimal places
    };

    const formatKm = (value) => {
        if (!value) return value;
        return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    };

    const formatLiter = (value) => {
        if (!value) return value;
        return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    };

    return (
        <table className="carconsumption-table">
            <thead>
                <tr>
                    <th>Dátum</th>
                    <th>Km-től</th>
                    <th>Km-ig</th>
                    <th>Megtett km</th>
                    <th>Tankolt liter</th>
                    <th>Fogyasztás</th>
                </tr>
            </thead>
            <tbody>
                {consumption?.map((row) => (
                    <tr key={row.date} className={`carconsumption-row`}>
                        <td className="date">{row.date}</td>
                        <td className="start-km">{formatKm(row.startKm)}</td>
                        <td className="end-km">{formatKm(row.endKm)}</td>
                        <td className="km">{formatKm(row.km)}</td>
                        <td className="km">{formatLiter(row.latestRefuel)}</td>
                        <td className="consumption">{formatConsumption(row.consumption)}</td>
                    </tr>
                ))
                }
            </tbody>
        </table>)
};
export default CarConsumption;